<template>
  <el-drawer
    title=""
    :visible.sync="drawerVisible"
    direction="rtl"
    :wrapperClosable="true"
    :close-on-press-escape="false"
    :show-close="false"
    :withHeader="false"
    size="100%"
    @close="closeDrawer"
  >
    <div class="search-container">
      <div class="search-top">
        <div class="search-input">
          <el-input v-model="keyword" placeholder="请输入搜索内容" @keyup.enter.native="searchHandleDB" @input="searchHandleDB">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchHandle"></i>
          </el-input>
        </div>
        <div class="search-cancel" @click="closeDrawer">取消</div>
      </div>
      <div class="search-result-title">搜索结果：</div>
      <div class="search-result">
        <div v-show="!searchResultList.length" class="blank-box">暂无数据</div>
        <div v-show="searchResultList.length" class="result-list">
          <div
            class="result-item ellipsis-2"
            v-for="(item, index) in searchResultList"
            :key="`${item.elementKey + index}`"
            @click="goPosition(item)"
            v-html="item.searchReturnText"
          ></div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>

import { debounce } from 'lodash'
export default {
  name: "search",
  props: {
    //drawer 是否展示
    visible: {
      type: Boolean,
      default: false,
    },
    bookContent: {
      type: Object,
      default: () => {
        return {};
      }
    },
    activeChapter: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      drawerVisible: false,
      keyword: '',
      searchResultList: []
    }
  },
  watch: {
    visible(newVal) {
      this.drawerVisible = newVal
    }
  },
  methods: {
    searchHandleDB: debounce(function() {
      this.searchHandle()
    }, 300),
    // 搜索整体数据
    searchHandle() {
      this.searchResultList = [];
      if(!this.keyword) return
      Object.keys(this.bookContent).forEach(key => {
        this.bookContent[key].forEach(sectionItem => {
          if(sectionItem.type === 'text') {
            // 搜索文本
            this.insertSearchResult(sectionItem, key)
          }else if(sectionItem.type === 'text-special') {
            sectionItem.content.forEach(pItem => {
              this.insertSearchResult(pItem, key)
            })
          }else if(sectionItem.type === 'table') {
            // 搜索表格
            sectionItem.content.forEach(item => {
              item.tableData.forEach(row => {
                Object.keys(row).forEach(unit => {
                  let tableKey = sectionItem.key
                  let tableTabKey = item.key
                  this.insertSearchResult(row[unit], key, tableKey, tableTabKey)
                })
              })
            })
          }else if(sectionItem.type === 'frame') {
            sectionItem.content.forEach(pItem => {
              this.insertSearchResult(pItem, key)
            })
          }else if(sectionItem.type === 'template') {
            // 搜索模板 处理英语中的组件嵌套
            this.searchTextInTemplate(sectionItem, key);
          }else if(sectionItem.type === 'paragraph') {
            this.insertSearchResult(sectionItem.content, key)
          }else if(sectionItem.type === 'workOrder') {
            sectionItem.content.forEach(pItem => {
              this.insertSearchResult(pItem, key)
            })
          }
        })
      })
    },
    // 模板嵌套搜索
    searchTextInTemplate(data, key) {
      if(data.content && Array.isArray(data.content)) {
        data.content.forEach(item => {
          if(item.type === 'text' && item.content && Array.isArray(item.content)) {
            this.insertSearchResult(item, key)
          }else if(item.type === 'template' || item.type === 'list') {
            this.searchTextInTemplate(item, key)
          }else if(item.type === 'paragraph') {
            this.insertSearchResult(item.content, key)
          }
        })
      }
    },
    // 清除搜索标记
    searchClearMark(elementKey) {
      let element = document.getElementById(elementKey)
      var mark_obj_arr = element.getElementsByTagName('span');
      mark_obj_arr = Array.prototype.slice.call(mark_obj_arr);
      for (var i = 0; i < mark_obj_arr.length; i++) {
        if (mark_obj_arr[i].getAttribute("data-search")) {
          // 清除文中被标记的标识
          // element.innerHTML = element.innerHTML.replace(mark_obj_arr[i].outerHTML, mark_obj_arr[i].innerHTML);
          mark_obj_arr[i].parentElement.innerHTML = mark_obj_arr[i].parentElement.innerHTML.replace(mark_obj_arr[i].outerHTML, mark_obj_arr[i].innerHTML);
          this.$forceUpdate();
        }
      }
    },
    // 所有搜索结果
    insertSearchResult(item, pageKey, tableKey, tableTabKey) {
      let keyword = this.keyword
      let searchStr = '';
      if(item.content) {
        item.content.forEach(spanItem => {
          searchStr += spanItem.text
        })
      }else if(item.fontContent) {
        item.fontContent.forEach(spanItem => {
          searchStr += spanItem.text
        })
      }
      
      let itemSearchResult = searchStr.match(new RegExp(keyword, 'g'))
      if(itemSearchResult) {
        let positions = this.getAllIndex(searchStr, keyword)
        for(let j = 0; j < itemSearchResult.length; j++) {
          if(pageKey === this.activeChapter) {
            // this.searchResultAddSign(item.key, positions[j])
          }
          // let returnText = searchStr.substring(positions[j] - 5, positions[j] + keyword.length + 5)
          let returnText = searchStr.substring(positions[j] - 5, positions[j])
          if(positions[j] > 5) {
            returnText = '...' + returnText
          }
          returnText += `<span style="color: #F96413;">${keyword}</span>`
          returnText += searchStr.substring(positions[j] + keyword.length, positions[j] + keyword.length + 5)
          if(searchStr.length - (positions[j] + keyword.length) > 5) {
            returnText = returnText + '...'
          }
          // returnText = returnText.replace(keyword, `<span style="color: #F96413;">${keyword}</span>`)
          // let searchTextIndex = searchReturnText.indexOf(keyword)
          // searchReturnText = searchReturnText.substring(searchTextIndex + keyword.length, searchReturnText.length)
          this.searchResultList.push({
            // searchReturnText: keyword + searchReturnText,
            position: positions[j],
            searchReturnText: returnText,
            elementKey: item.key,
            pageKey, tableKey, tableTabKey
          })
          // let searchTextHtml = searchTextSplitList[j+1]
        }
      }
    },
    // 给指定位置的内容增加标记
    searchResultAddSign(elementKey, position) {
      let keyword = this.keyword
      let element = document.getElementById(elementKey)
      let nodes = this.getAllChildrenNodes(element)
      nodes = nodes.filter(node => {
        // console.log(node.tagName)
        return node.nodeType === 3 || node.tagName === 'SPAN'
      })
      let randomValue = Math.random().toString(36).substring(2, 15);
      let markIndex = 0
      nodes.forEach(node => {
        let textContent = node.textContent;
        if(markIndex >= position + keyword.length) return false;
        if((textContent.length + markIndex) < position) {
          markIndex += textContent.length;
          return false;
        } else if(markIndex < position && (textContent.length + markIndex) > position) {
          let endIndex = Math.min(textContent.length, position + keyword.length - markIndex)
          // textContent = textContent.substring(position - markIndex, endIndex)
          let newMarkEl = document.createElement("span");
          newMarkEl.style.backgroundColor = "orange";
          newMarkEl.style.color = "black";
          newMarkEl.style.userSelect = "text";
          newMarkEl.setAttribute("data-search", randomValue);
          // 设置唯一
          newMarkEl.setAttribute("id", randomValue);
          newMarkEl.innerHTML = textContent.substring(position - markIndex, endIndex);
          textContent = textContent.substring(0, position - markIndex) + newMarkEl.outerHTML + textContent.substring(endIndex, textContent.length)
        } else if(textContent.length + markIndex >= position + keyword.length) {
          let startIndex = Math.max(0, position - markIndex)
          // textContent = textContent.substring(startIndex, position + keyword.length - markIndex)
          let newMarkEl = document.createElement("span");
          newMarkEl.style.backgroundColor = "orange";
          newMarkEl.style.color = "black";
          newMarkEl.style.userSelect = "text";
          newMarkEl.setAttribute("data-search", randomValue);
          // 设置唯一
          newMarkEl.setAttribute("id", randomValue);
          newMarkEl.innerHTML = textContent.substring(startIndex, position + keyword.length - markIndex);
          textContent = textContent.substring(0, startIndex) + newMarkEl.outerHTML + textContent.substring(position + keyword.length - markIndex, textContent.length)
        } else if(textContent.length + markIndex < position + keyword.length && markIndex > position) {
          let newMarkEl = document.createElement("span");
          newMarkEl.style.backgroundColor = "orange";
          newMarkEl.style.color = "black";
          newMarkEl.style.userSelect = "text";
          newMarkEl.setAttribute("data-search", randomValue);
          // 设置唯一
          newMarkEl.setAttribute("id", randomValue);
          newMarkEl.innerHTML = textContent;
          textContent = newMarkEl.outerHTML
        } else {
          markIndex += node.textContent.length
          return false;
        }
        
        this.$nextTick(() => {
          setTimeout(() => {
            // element.innerHTML = element.innerHTML.replace(node.textContent, textContent)
            if(node.nodeType === 3) {
              node.parentElement.innerHTML = node.parentElement.innerHTML.replace(node.nodeValue, textContent)
            }else{
              node.innerHTML = node.innerHTML.replace(node.innerHTML, textContent)
            }
            this.$forceUpdate()
          })
        })
        markIndex += node.textContent.length
      })
    },
    // 获取某一节点下的所有节点
    getAllChildrenNodes(node) {
      if(node.classList && node.classList.contains('el-popover')) {
        return []
      }
      let nodes = node.childNodes
      let allNodes = []
      if(nodes.length === 1 && nodes[0].nodeType === 3) {
        return []
      }else{
        for(let i = 0; i < nodes.length; i++) {
          if(nodes[i].classList && nodes[i].classList.contains('el-popover')) {
            allNodes = []
          }else{
            if(nodes[i].nodeType === 3) {
              allNodes.push(nodes[i])
            }else if(nodes[i].nodeType === 1){
              let childNodes = this.getAllChildrenNodes(nodes[i])
              if(childNodes.length === 0) {
                allNodes.push(nodes[i])
              }
              allNodes = [...allNodes, ...childNodes]
            }
          }
        }
      }
      return allNodes
    },
    // 只能搜索本页内容
    searchHandle1() {
      // this.$emit('searchHandle', this.keyword)
      let keyword = this.keyword
      
      // let content = this.$refs.bookContent.$el.innerHTML.replace(/<[^>]*>|/g,"");
      // console.log(content)
      // console.log(content.match(new RegExp(keyword, 'g')))
      // console.log(this.$refs.bookContent.$el.textContent)
      let elementP = document.getElementsByTagName('p')
      this.searchResultList = [];
      for(let i = 0; i < elementP.length; i++) {
        let itemSearchResult = elementP[i].textContent.match(new RegExp(keyword, 'g'))
        let canSearch = elementP[i].classList.contains('content_text')
        if(itemSearchResult && canSearch) {
          let pText = elementP[i].textContent
          let positions = this.getAllIndex(pText, keyword)
          for(let j = 0; j < itemSearchResult.length; j++) {
            let returnText = pText.substring(positions[j] - 5, positions[j] + keyword.length + 5)
            // let searchTextIndex = searchReturnText.indexOf(keyword)
            // searchReturnText = searchReturnText.substring(searchTextIndex + keyword.length, searchReturnText.length)
            this.searchResultList.push({
              // searchReturnText: keyword + searchReturnText,
              position: positions[j],
              searchReturnText: returnText,
              elementP: elementP[i]
            })
            // let searchTextHtml = searchTextSplitList[j+1]
          }
        }
      }
    },
    // 获取一段文字中的一小段文字的所有出现的位置
    getAllIndex(text, searchString) {
      const regex = new RegExp(searchString, 'g');
      let match;
      const positions = [];
      
      while ((match = regex.exec(text))) {
        positions.push(match.index);
      }
      
      return positions;
      // const regex = new RegExp(searchString, 'g'); // 'g' 标志表示全局匹配
      // const matches = text.match(regex);
      // if (!matches) {
      //   return [];
      // }
      // console.log(text, searchString)
      // console.log(matches)
      // const indexes = matches.map((match, index) => {
      //   const startIndex = text.indexOf(match, index === 0 ? 0 : matches[index - 1].length);
      //   return startIndex;
      // });
      // return indexes;
    },
    // 定位到搜索结果的位置
    async goPosition(item) {
      this.closeDrawer();
      await this.chapterChange(item);
      this.toElement(item);
    },
    toElement(item) {
      const element = document.getElementById(item.elementKey);
      if(!element) {
        setTimeout(() => {
          this.toElement(item);
        }, 100)
        return false
      }
      this.$nextTick(() => {
        setTimeout(()=> {
          // 导航滚动定位
          element.scrollIntoView({
            behavior: 'smooth', // 平滑滚动
            block: "start", // 垂直居中对齐
          });
          this.searchResultAddSign(item.elementKey, item.position);
          setTimeout(() => {
            this.searchClearMark(item.elementKey);
          }, 3000)
        }, 100);
      })
    },
    // 切换章节以及表格的tab
    chapterChange(item) {
      return new Promise((resolve) => {
        this.$emit('chapterChange', item.pageKey, true, () => {
          this.$nextTick(() => {
            setTimeout(()=> {
              if(item.tableKey) {
                this.$emit('tableTabChange', item.tableKey, item.tableTabKey);
              }
              resolve()
            }, 20);
          });
        });
      })
    },
    // 关闭弹窗
    closeDrawer() {
      this.$emit('closeDrawer', 'menu')
    },
  }
}
</script>
<style lang="scss" scoped>
.search-container{

  .search-top{
    padding: 20rem 24rem 30rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .search-input{
      width: 600rem;
      height: 70rem;
      line-height: 70rem;
      border-bottom: 1rem solid #E3E3E3;

      input{
        border-radius: 6rem;
      }
    }

    .search-cancel{
      font-size: 28rem;
      color: #333;
      margin-right: 13rem;
    }
  }

  .search-result-title{
    // width: 702rem;
    margin: 0 24rem;
    padding: 22rem 0 14rem;
    font-size: 24rem;
    line-height: 40rem;
    color: #999;
    border-bottom: 1rem dashed #E3E3E3;
  }

  .search-result{
    .blank-box {
      margin: 180rem auto 60rem;
      padding-top: 30%;
      font-size: 28rem;
      text-align: center;
      color: #a5b3c6;
      width: 450rem;
      height: 300rem;
      background: url("~@/assets/images/common/blank_pic.png") center center no-repeat;
      background-size: contain;
    }

    .result-list{
      padding-top: 20rem;

      .result-item{
        font-size: 28rem;
        line-height: 38rem;
        padding: 20rem 36rem;
        color: #333;
      }
    }
  }
}
/deep/.el-input{
  font-size: 26rem;

  .el-input__inner {
    border-radius: 6rem;
    height: 72rem;
    line-height: 72rem;
    padding: 0 18rem;
    padding-right: 48rem;
  }
  
  .el-input__inner:focus{
    border-color: #0FC29A;
  }

  .el-input__suffix{
    color: #666666;
  }
}
</style>